export default "__VITE_ASSET__BgkKWV5U__"